﻿import WMSCapabilities from 'ol/format/WMSCapabilities';
import TileWMS from 'ol/source/TileWMS.js';
import TileLayer from 'ol/layer/Tile.js';
import { Utility } from '../Utility.js';
export { OgcLayerTool };

/**
 * Class Identify
 */
const OgcLayerTool = function () {

	// Define this
    var myOgcLayerTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Utility
    this._utility = new Utility();

    // Map
    this._mapSgs = null;

    // Layer Id
    this._layerIdService = null;

    // Layer found
    this._layerFeatureFound = {};

    //datatable OGC
    this._datatableOGCServices = null;

    //Verify if is edit ou create
    this._createnewService = true;

    //Verify if is edit ou create
    this._idServiceToEdit = null;

    // External Layers
    this._urlLinkExternoWMS = [];

    // External Layers
    this._layerLinkExternoWMS = [];

    // External layer id
    this._idLayerExternal = 0;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // -- end public variable ---------------------------------------------------------------------

    // -- begin public method ---------------------------------------------------------------------

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    this._GetAllReference = function()
    {
        $.ajax({
            type: 'GET',
            url: '/rest/app/OgcLayerTool/GetAllReference',
            async: true,
            dataType: 'json',
            contentType: "application/json",
            success: function (data)
            {
                if (data.error) {
                    toastr["error"]("Erro obtenção da informação de referencia dos servicos OGC");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // -- Protocol --
                            var listLayerProtocol = data.result.listLayerProtocol;
                            myOgcLayerTool._utility.FillSelect('id-select-protocol-new-ogc-service', listLayerProtocol, 'code', 'id', true);
                            // Only use WMS for now
                            $('#id-select-protocol-new-ogc-service').val(2);
                            $('#id-select-protocol-new-ogc-service').attr('disabled',true);
                            $('#id-select-protocol-new-ogc-service').selectpicker("refresh");
                            break;
                        default:
                            toastr["error"]("Erro obtenção da informação de referencia dos servicos OGC");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro obtenção da informação de referencia dos servicos OGC");
            }
        });
    }

    /**
     * Build table with all the ogc service created
     */
    this._BuildCatalogOgcServiceTable = function()
    {
        // -- init column def --
        var columnDefArrayOgcLayer = [];

        columnDefArrayOgcLayer.push({
            'data': 'id',
            'type': 'readonly',
            'visible': false
        });

        // button
        columnDefArrayOgcLayer.push({
            'name': 'button_config_element',
            'className': 'dt-body-center dt-font',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-config-element remove-service-ogc on-button"><i class="gj-icon delete" style="color: #ff3d00"></i></a>',
            'width': '3%'
        });

        // button
        columnDefArrayOgcLayer.push({
            'name': 'button_config_element',
            'className': 'dt-body-center dt-font',
            'data': null,
            'orderable': false,
            'defaultContent': '<a class="button-config-element edit-service-ogc on-button"><i class="fa fa-pencil" style="color: #ff3d00"></i></a>',
            'width': '3%'
        });

        // Description
        columnDefArrayOgcLayer.push({
            'id': 'name',
            'data': 'name',
            'title': 'Nome',
            'width': '30%',
            'type': 'readonly'
        });

        // Description
        columnDefArrayOgcLayer.push({
            'id': 'url',
            'data': 'url',
            'title': 'URL',
            'render': function (data, type, row) {
                if (data.length > 40) {
                
                    return '<span title="' + data +'" >' + data.substring(0, 40) + "..."; + '</span>' 
                } else {
                    return 'Sem descrição';
                }
            },
            'width': '10%',
            'type': 'readonly'
        });

        // Description
        columnDefArrayOgcLayer.push({
            'id': 'description',
            'data': 'description',
            'title': 'Descrição',
            'width': '40%',
            'type': 'readonly'
        });

        // Id protocol
        columnDefArrayOgcLayer.push({
            'data': 'id_rel_layer_protocol',
            'type': 'readonly',
            'visible': false
        });

        // Code Protocol
        columnDefArrayOgcLayer.push({
            'id': 'code_layer_protocol',
            'data': 'code_layer_protocol',
            'title': 'Protocolo',
            'width': '20%',
            'type': 'readonly'
        });

        myOgcLayerTool._datatableOGCServices = $('#id-modal-ogc-layer-body-table').DataTable({
            "destroy": true,
            "language": {
                "search": "Procurar",
                "emptyTable": 'Nenhum serviço encontrado',
                "paginate": {
                    "previous": '<i class="fa fa-caret-left"></i>',
                    "next": '<i class="fa fa-caret-right"></i>',
                    "first": '<i class="fa fa-step-backward"></i>',
                    "last": '<i class="fa fa-step-forward"></i>'
                }
            },
            //"fixedHeader": false,
            //"filter": true,
            "info": false,
            "scrollCollapse": true,
            "deferRender": false,
            "scroller": false,
            "ordering": false,
            "columns": columnDefArrayOgcLayer,
            "select": true,
            "paging": true,
            "pageLength": 5,
            "name": "LayerSource_style",
            "rowId": 'id',
            "searchable": true,
            "lengthChange": false,
            //"scrollX": true,
            //"scrollY": "300px",
            //"autoWidth": true,
            "iDisplayLength": 10,
            "initComplete": function(settings, json)
            {
                $.ajax({
                    type: 'GET',
                    url: '/rest/app/OgcLayerTool/GetAllServices',
                    async: true,
                    dataType: 'json',
                    contentType: "application/json",
                    success: function (data)
                    {
                        if (data.error) {
                            toastr["error"]("Erro na obtenção da informação dos serviços OGC");
                        }
                        else
                        {
                            switch (data.result.status) {
                                case 'SUCCESS':
                                    var listOgcServices = data.result.listOgcServices;
                                    myOgcLayerTool._datatableOGCServices.clear();

                                    var countElement = listOgcServices.length;
                                    for (let i = 0; i < countElement; i++) {
                                        var objEvent = listOgcServices[i];
                                        myOgcLayerTool._datatableOGCServices.row.add({
                                            id: objEvent.id,
                                            name: objEvent.name,
                                            url: objEvent.url,
                                            description: objEvent.description,
                                            dt_process: objEvent.dt_process,
                                            id_rel_layer_protocol: objEvent.id_rel_layer_protocol,
                                            code_layer_protocol: objEvent.code_layer_protocol
                                        });
                                    }
                                    myOgcLayerTool._datatableOGCServices.draw();
                                    break;
                                default:
                                    toastr["error"]("Erro na obtenção da informação dos serviços OGC");
                            }
                        }
                    },
                    error: function (request, status, error) {
                        toastr["error"]("Erro na obtenção da informação dos serviços OGC");
                    }
                });
            }
        });
    }

    /**
     * Load in map the wms ogc service
     * @param {string} urlWMS, get capability url service
     */
    this._LoadWMS = function(urlWMS)
    {
        var layerSourceLinkExternoWMS;
        var linkExternoWMS = [];
        linkExternoWMS[0] = urlWMS;
        
        for (var i = 0; i < linkExternoWMS.length; ++i) {
            var parser = new WMSCapabilities();
            fetch(linkExternoWMS[i]).then(function (response) {
                return response.text();
            }).then(function (text) {
                var result = parser.read(text);
                //console.log (result.Capability.Layer.Title);

                var layerMapaTitle = result.Capability.Layer.Title;

                if (result.Capability.Layer.Layer.length > 0) {

                    var titleLegenda = document.createElement('div');
                    //titleLegenda.className = 'divVMSLegendaTitle';
                    document.getElementById('layer-tree-external').appendChild(titleLegenda);

                    for (i = 0; i < result.Capability.Layer.Layer.length; ++i) {

                        var layerWMSName = result.Capability.Layer.Layer[i].Name;
                        var layerWMSTitle = result.Capability.Layer.Layer[i].Title;
                        layerSourceLinkExternoWMS = new TileWMS({
                            url: result.Capability.Request.GetMap.DCPType[0].HTTP.Get.OnlineResource,
                            params: { 'LAYERS': layerWMSName, 'TILED': true },
                            crossOrigin: 'anonymous'
                        });
                        var layerExternal = new TileLayer({
                            name: layerWMSName + '_"'+ myOgcLayerTool._idLayerExternal,
                            id: layerWMSName + '_' + myOgcLayerTool._idLayerExternal,
                            title: layerWMSTitle,
                            source: layerSourceLinkExternoWMS
                        });

                        myOgcLayerTool._layerLinkExternoWMS.push(layerExternal)

                        myOgcLayerTool._mapSgs.map.addLayer(myOgcLayerTool._layerLinkExternoWMS[myOgcLayerTool._idLayerExternal]);

                        var legend = document.getElementById('layer-tree-external');

                        //if (i == 0) {
                        //    legend.innerHTML += '<p class="pCapabilityLayerMapTitle "><i class="ms-Icon ms-Icon--Nav2DMapView" aria-hidden="true"></i> ' + layerMapaTitle + '</p>';
                        //}                            

                        var updateLegend = function (resolution) {
                            //var img = document.createElement('img');
                            var graphicUrl = result.Capability.Layer.Layer[i].Style[0].LegendURL[0].OnlineResource;
                            //img.src = graphicUrl;
                            legend.innerHTML += '<div id="id-layer-external-btn-zone-'+ myOgcLayerTool._idLayerExternal + '" class="layer-external-btn-zone">' +
                                                  '<div class="row" style="margin:0px;">' +
                                                    '<i id="id-layer-external-remove-' + myOgcLayerTool._idLayerExternal + '" id-layer-external="' + myOgcLayerTool._idLayerExternal + '" class="gj-icon delete layer-external-remove icon-external-layer"></i>' +
                                                    '<i id="id-layer-external-save-' + myOgcLayerTool._idLayerExternal + '" id-layer-external="' + myOgcLayerTool._idLayerExternal + '" class="material-icons layer-external-save icon-external-layer">save</i>' +
                                                    '<i id="id-layer-external-visible-' + myOgcLayerTool._idLayerExternal + '" id-layer-external="' + myOgcLayerTool._idLayerExternal + '" class="material-icons layer-external-visible icon-external-layer visible">layers</i>' +
                                                  '</div>' +
                                                  '<div class="row" style="margin: 0px;margin-left: -10px;">' +
                                                    '<label class="layer-tree-external-service-name">' + result.Capability.Layer.Layer[i].Title + '</label>' +
                                                  '</div>' +
                                                  '<div class="row" style="margin: 0px;margin-left: 0px;">' +
                                                    '<img class="layer-tree-external-service-img" src="' + graphicUrl + '"></img>'+
                                                  '</div>' +
                                                '</div>';
                        };

                        var resolution = myOgcLayerTool._mapSgs.map.getView().getResolution();
                        updateLegend(resolution);

                        myOgcLayerTool._idLayerExternal++;
                    }

                    myOgcLayerTool._urlLinkExternoWMS.push(urlWMS);

                    // Event to remove from lauer tree ogc service
                    $('.layer-external-remove').off('click').on('click', function ()
                    {
                        var idlayerExternal = $(this).attr("id-layer-external");
                        $('#id-layer-external-btn-zone-'+ idlayerExternal).remove();
                        myOgcLayerTool._mapSgs.map.removeLayer(myOgcLayerTool._layerLinkExternoWMS[idlayerExternal]);
                    });

                    // Event for create the ogc service in the catalog
                    $('.layer-external-save').off('click').on('click', function ()
                    {
                        myOgcLayerTool._createnewService = true;

                        $('#id-input-name-new-ogc-service').val('');
                        $('#id-input-url-new-ogc-service').val('');
                        $('#id-input-description-new-ogc-service').val('');
                        myOgcLayerTool._layerIdService = $(this).attr("id-layer-external");
                        $('#id-input-url-new-ogc-service').val(myOgcLayerTool._urlLinkExternoWMS[myOgcLayerTool._layerIdService]);
                        $('.modal-content-save-filter-ogc-service label')[0].innerHTML = "Criar Serviço OGC";

                        $('#id-modal-save-new-ogc-service').modal('show');
                    });

                    // Event de visibilidade da camada
                    $('.layer-external-visible').off('click').on('click', function ()
                    {
                        var idlayerExternal = $(this).attr("id-layer-external");
                        if($(this).hasClass("visible"))
                        {
                            myOgcLayerTool._layerLinkExternoWMS[idlayerExternal].setVisible(false);
                            $(this)[0].innerHTML = 'layers_clear';
                        }
                        else
                        {
                            myOgcLayerTool._layerLinkExternoWMS[idlayerExternal].setVisible(true);
                            $(this)[0].innerHTML = 'layers';
                        }
                        $(this).toggleClass("visible");
                    });
                }
            });
        }
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    /**
     * Event remove servce ogc from catalog
     */
    $('#id-modal-ogc-layer-body-table').on('click', '.remove-service-ogc', function ()
    {
        var idOgcService = this.closest('tr').id;

        $.ajax({
            type: 'DELETE',
            url: '/rest/app/OgcLayerTool/RemoveService?id=' + idOgcService,
            async: true,
            dataType: 'json',
            contentType: "application/json",
            success: function (data)
            {
                if (data.error) {
                    toastr["error"]("Erro na remoção do serviços OGC");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myOgcLayerTool._datatableOGCServices.row('#' + idOgcService).remove().draw();

                            toastr["success"]("Serviços OGC removido com sucesso");
                            break;
                        default:
                            toastr["error"]("Erro na remoção do serviços OGC");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na remoção do serviços OGC");
            }
        });
    });

    /**
     * Event edit ogc service
     */
    $('#id-modal-ogc-layer-body-table').on('click', '.edit-service-ogc', function ()
    {
        myOgcLayerTool._createnewService = false;
        var idService = this.closest('tr').id;

        $.ajax({
            type: 'GET',
            url: '/rest/app/OgcLayerTool/GetServiceById?id=' + idService,
            async: true,
            dataType: 'json',
            contentType: "application/json",
            success: function (data)
            {
                if (data.error) {
                    toastr["error"]("Erro obtenção da informação do serviços OGC");
                }
                else
                {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var ogcService = data.result.ogcService;

                            myOgcLayerTool._idServiceToEdit = idService;
                            $('#id-input-name-new-ogc-service').val(ogcService.name);
                            $('#id-input-url-new-ogc-service').val(ogcService.url);
                            $('#id-input-description-new-ogc-service').val(ogcService.description);
                            $('.modal-content-save-filter-ogc-service label')[0].innerHTML = "Editar Serviço OGC";
                            $('#id-modal-save-new-ogc-service').modal('show');
                            break;
                        default:
                            toastr["error"]("Erro obtenção da informação do serviços OGC");
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro obtenção da informação do serviços OGC");
            }
        });
    });

    /**
     * Event open modal catalog ogc service
     */
    $('#id-add-saved-url-layertree').on('click', function () {
        $('#id-modal-ogc-layer').modal('show');
    });

    /**
     * Event close modal catalog ogc service
     */
    $('#id-modal-ogc-layer-close').on('click', function () {
        $('#id-modal-ogc-layer').modal('hide');
    });

    /**
     * Event Btn layer tree footer - Add service ogc to layer tree and map
     */
    $('#id-add-url-layertree').on('click', function () {

        if ($('#id-add-url-layertree .material-icons').html() == 'add') {
            $('#id-add-url-layertree .material-icons').html('done');
            $('#id-textarea-url-ogc-layertree').toggle('ol-hidden');
            $('#id-textarea-url-ogc-layertree').val('');
            $('.offcanvas-theme').mCustomScrollbar("scrollTo", "last");

        }
        else if ($('#id-add-url-layertree .material-icons').html() == 'done')
        {
            var url = $('#id-textarea-url-ogc-layertree').val();
            if(url === "" )
            {
                toastr["warning"]("Introduza primeiro um serviços OGC");
                return;
            }

            myOgcLayerTool._LoadWMS(url);

            $('#id-add-url-layertree .material-icons').html('add');
            $('#id-textarea-url-ogc-layertree').toggle('ol-hidden');
        }
    });

    /**
     * Event Close edition or creation modal service ogc
     */
    $('#id-cancel-new-ogc-service').on('click', function () {
        $('#id-modal-save-new-ogc-service').modal('hide');
    })

    /**
     * Add new service ogc to catalog
     */
    $('#id-modal-ogc-layer-add-new').on('click', function () {

        myOgcLayerTool._createnewService = true;

        $('#id-input-name-new-ogc-service').val('');
        $('#id-input-url-new-ogc-service').val('');
        $('#id-input-description-new-ogc-service').val('');
        $('.modal-content-save-filter-ogc-service label')[0].innerHTML = "Criar Serviço OGC";
        $('#id-modal-save-new-ogc-service').modal('show');
    });

    /**
     * Event add service ogc selected from catalog to map
     */
    $('#id-modal-add-ogc-layer-to-map').on('click', function ()
    {
        var ServiceSelected = myOgcLayerTool._datatableOGCServices.rows('.selected').data();

        if(ServiceSelected.toArray().length === 0)
        {
            toastr["warning"]("Seleccione primeiro um serviço");
            return;
        }

        $('#id-modal-ogc-layer').modal('hide');

        myOgcLayerTool._LoadWMS(ServiceSelected[0].url);
    })

    /**
     * Event create or save ogc service
     */
    $('#id-confirm-new-ogc-service').on('click', function ()
    {
        var urlService = escape($('#id-input-url-new-ogc-service').val());
        var nameService = $('#id-input-name-new-ogc-service').val();
        var description = $('#id-input-description-new-ogc-service').val()
        var idProtocol = $('#id-select-protocol-new-ogc-service').val();
        var protocolText = $('#id-select-protocol-new-ogc-service').find("option:selected").text();
        var userId = myOgcLayerTool._mapSgs._settings.userInfo.userId;

        // -- Create new service ogc to add to catalog --
        if (myOgcLayerTool._createnewService == true)
        {
            $.ajax({
                type: 'POST',
                url: '/rest/app/OgcLayerTool/CreateNewServiceOGC?urlService=' + urlService + '&nameService=' + nameService + '&description=' + description + '&userId=' + userId,
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: function (data)
                {
                    if (data.error) {
                        toastr["error"]("Erro criação do serviços OGC");
                    }
                    else
                    {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                var ogcService = data.result.ogcService;

                                myOgcLayerTool._datatableOGCServices.row.add({
                                    id: ogcService.id,
                                    name: ogcService.name,
                                    url: ogcService.url,
                                    description: ogcService.description,
                                    id_rel_layer_protocol: idProtocol,
                                    code_layer_protocol: protocolText
                                });
                                myOgcLayerTool._datatableOGCServices.draw();

                                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                                $('#id-modal-save-new-ogc-service').modal('hide');

                                toastr["success"]("Serviço ogc criado com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro criação do serviços OGC");
                        }

                    }
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro criação do serviços OGC");
                }
            });
        }
        else
        {
            // -- Save ogc service --

            $.ajax({
                type: 'POST',
                url: '/rest/app/OgcLayerTool/SaveService?urlService=' + urlService + '&nameService=' + nameService + '&description=' + description + '&userId=' + userId + '&idOgcService=' + myOgcLayerTool._idServiceToEdit,
                async: true,
                dataType: 'json',
                contentType: "application/json",
                success: function (data)
                {
                    if (data.error) {
                        toastr["error"]("Erro gravação do serviços OGC");
                    }
                    else
                    {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                myOgcLayerTool._datatableOGCServices.cell('#' + myOgcLayerTool._idServiceToEdit, 3).data(nameService).draw();
                                myOgcLayerTool._datatableOGCServices.cell('#' + myOgcLayerTool._idServiceToEdit, 4).data(urlService).draw();
                                myOgcLayerTool._datatableOGCServices.cell('#' + myOgcLayerTool._idServiceToEdit, 5).data(description).draw();

                                $($.fn.dataTable.tables(true)).DataTable().columns.adjust();

                                $('#id-modal-save-new-ogc-service').modal('hide');

                                toastr["success"]("Serviço ogc gravado com sucesso");
                                break;
                            default:
                                toastr["error"]("Erro gravação do serviços OGC");
                        }
                    }
                },
                error: function (request, status, error) {
                    toastr["error"]("Erro gravação do serviços OGC");
                }
            });
        }
    })

    // -- end event -------------------------------------------------------------------------------    
};

/**
 * Init ogc layer tool
 * @param {object} mapSgs, map object
 */
OgcLayerTool.prototype.Init = function (mapSgs)
{
    // Set map info
    this._mapSgs = mapSgs;

    // Build table all ogc service
    this._BuildCatalogOgcServiceTable();

    // Get all reference 
    this._GetAllReference();
}
